export const REGISTER_ATTEMPT = 'REGISTER_ATTEMPT';
export type REGISTER_ATTEMPT = typeof REGISTER_ATTEMPT;

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export type REGISTER_SUCCESS = typeof REGISTER_SUCCESS;

export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export type REGISTER_FAILURE = typeof REGISTER_FAILURE;

export const REGISTER_CLEAR_ERRORS = 'REGISTER_CLEAR_ERRORS';
export type REGISTER_CLEAR_ERRORS = typeof REGISTER_CLEAR_ERRORS;


// WEBPACK FOOTER //
// ./src/actions/authentication/register/Types.tsx